import { type InitContext } from "@btnet/services-btnet/handlers/models/initContext";

import { loadInitContext } from "utilities/init/initContext";

/**
 * The resolved bootstrap ("init") context — Datadog RUM and Sentry config fetched from
 * `GET /apix/v2/context/init` by the inline script in index.html.
 *
 * The `await` lives here, in a module of its own, rather than directly in `index-app.tsx`.
 * That placement is load-bearing: a top-level `await` in the entry module changes Rollup's
 * chunking so that shared modules are split into their own chunks instead of being hoisted
 * into the entry chunk. Their CSS then loads *before* the entry bundle's, which reorders the
 * stylesheets and flips the winner of any equal-specificity rules sharing the `app` cascade
 * layer — that is what shipped antd's dark `Layout.Header` and broke form-input spacing
 * (ADO 283955, reverted by PR 108852).
 *
 * Awaiting from a separate module was measured to produce the same 479 CSS chunks as having
 * no `await` at all, with none of the seven shared modules split out. The exact Rollup
 * heuristic behind that is not characterised, so treat this file's existence as a
 * measured constraint: re-inlining the `await` into `index-app.tsx` reintroduces the split.
 * Verify with the chunk-count check in the ADO 283956 PR description before moving it.
 *
 * `loadInitContext()` never rejects — it resolves to a fully-disabled config when the request
 * fails, times out, or the payload is malformed — so this `await` cannot break app startup.
 */
export const initContext: InitContext = await loadInitContext();
